import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { useAuth } from '../lib/auth';

export default function CheckoutSuccess() {
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const tier = params.get('tier');
  const to = params.get('to');
  const isGift = tier === 'gift';

  // Stripe's redirect happens before the webhook finishes processing,
  // so we refresh /api/me once on land and again after a short delay
  // to give the webhook a chance to write the cosmetic + subscription rows.
  useEffect(() => {
    void refresh();
    const t = setTimeout(() => void refresh(), 4000);
    return () => clearTimeout(t);
  }, [refresh]);

  const heading = isGift
    ? 'Thanks for the gift!'
    : tier === 'subscriber'
      ? 'Thanks for subscribing to StreamNook'
      : 'Thanks for supporting StreamNook';
  const body = isGift
    ? `The Subscriber badge and StreamNook Atmospheres are on their way to ${to ? `@${to}` : 'your recipient'}'s account.`
    : 'Your cosmetic should appear on your account within a few seconds. Open the StreamNook desktop app to equip it.';

  return (
    <div className="text-center py-16 space-y-5 max-w-xl mx-auto">
      <CheckCircle2 className="w-14 h-14 text-success mx-auto" />
      <h1 className="text-3xl font-semibold">{heading}</h1>
      <p className="text-textSecondary">{body}</p>
      <div className="flex justify-center gap-3 pt-2">
        <Link to="/account" className="glass-button px-4 py-2 text-sm font-medium">
          Go to my account
        </Link>
        <Link to="/" className="px-4 py-2 text-sm text-textSecondary hover:text-textPrimary">
          Back home
        </Link>
      </div>
    </div>
  );
}
